export default __webpack_public_path__ + "static/media/1.9ff91e18.webp";